import { render } from "./RequestTypeForm.vue?vue&type=template&id=59b970b9&scoped=true"
import script from "./RequestTypeForm.vue?vue&type=script&lang=js"
export * from "./RequestTypeForm.vue?vue&type=script&lang=js"

import "./RequestTypeForm.vue?vue&type=style&index=0&id=59b970b9&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b970b9"]])

export default __exports__